<ng-container *appHasPermission="{ resource: Resources.MerchantAccounts, scope: Scopes.Access }">
  <!-- Section Header -->
  @if (!openAddUser && !openUserDetails) {
    <div class="section-header">
      <div class="header-left">
        <h3 class="section-title">Users ({{ totalCount() }})</h3>
        <app-button
          *appHasPermission="{ resource: Resources.MerchantAccounts, scope: Scopes.Create }"
          buttonVariant="accent-add"
          buttonType="button"
          (buttonClick)="onAddAccount()"
          >
          <mat-icon>add</mat-icon>
          <span class="text"> Add User </span>
        </app-button>
      </div>
      <!-- Filter Controls -->
      <div class="filter-controls">
        <!-- Sort By Dropdown -->
        <app-pill-dropdown
          dropdownId="sort"
          [options]="sortOptionsLabels"
          [selectedOption]="selectedSortOption"
          (optionSelected)="onOptionSelected($event)"
          (cleared)="onCleared($event)"
          />
        <!-- Status Dropdown -->
        <app-pill-dropdown
          dropdownId="status"
          [options]="statusOptionsLabels"
          [selectedOption]="selectedStatusOption"
          (optionSelected)="onOptionSelected($event)"
          (cleared)="onCleared($event)"
          />
        <!-- Role Dropdown -->
        <app-pill-dropdown
          dropdownId="role"
          [options]="roleOptionsLabels"
          [selectedOption]="selectedRoleOption"
          (optionSelected)="onOptionSelected($event)"
          (cleared)="onCleared($event)"
          />
        <!-- Search Field -->
        <app-pill-search [searchText]="searchTerm" placeholder="Search" (searchChange)="onSearchChange($event)" />
      </div>
    </div>
  }

  <!-- Accounts Grid -->
  <ng-container *appHasPermission="{ resource: Resources.MerchantAccounts, scope: Scopes.Read }">
    @if (!openAddUser && !openUserDetails) {
      <div class="accounts-content">
        @if (!loading()) {
          <ng-container>
            <div class="accounts-grid">
              @if (filteredAccounts.length > 0) {
                <app-virtual-scroll [items]="filteredAccounts" size="account" [viewportHeight]="listViewportHeight(945)">
                  <ng-template let-account>
                    <app-account-card [account]="account" [variant]="'merchant'" (click)="onAccountClick(account)" />
                  </ng-template>
                </app-virtual-scroll>
              } @else {
                <div class="empty-state">
                  <div class="empty-state-card">
                    <h3 class="empty-state-title">
                      {{ 'No matching results' }}
                    </h3>
                  </div>
                </div>
              }
            </div>
          </ng-container>
        } @else {
          <div class="loading-container">
            <app-loading-spinner size="large" label="Loading users..."></app-loading-spinner>
          </div>
        }
      </div>
    }
  </ng-container>

  @if (openAddUser) {
    <app-add-account return="merchant" (closed)="closeAddUser()" (accountCreated)="reloadAccounts()" />
  }

  @if (openUserDetails) {
    <app-account-detail
      return="merchant"
      (closed)="closeUserDetails()"
      [userId]="selectedUserId"
      [merchantId]="merchantId"
      [isMerchant]="isMerchant"
      />
  }
</ng-container>
